import { useState } from 'react';
import { cn } from '../../lib/cn';

function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((s) => s[0] ?? '')
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

/** Small avatar: shows the image when available, falls back to initials on empty/error. */
export function Avatar({
  src,
  name,
  className,
}: {
  src?: string;
  name?: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const initials = initialsOf(name ?? '');
  const showImg = src && !failed;
  return (
    <span
      className={cn(
        'bg-muted text-muted-foreground inline-flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full text-[10px] font-medium',
        className,
      )}
      title={name}
    >
      {showImg ? (
        <img
          src={src}
          alt={name ?? ''}
          className="size-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : (
        initials || '?'
      )}
    </span>
  );
}
